'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.simpleMovingAverageArray = undefined;

var _binaryUtils = require('binary-utils');

var _math = require('./math');

var simpleMovingAverage = function simpleMovingAverage(data, config) {
    var periods = config.periods,
        field = config.field;


    if (data.length < periods) {
        throw new Error('Periods longer than data length');
    }

    var vals = (0, _math.takeLast)(data, periods, field);

    return (0, _math.sum)(vals) / periods;
};

var simpleMovingAverageArray = exports.simpleMovingAverageArray = function simpleMovingAverageArray(data, config) {
    var periods = config.periods,
        _config$pipSize = config.pipSize,
        pipSize = _config$pipSize === undefined ? 2 : _config$pipSize;

    return (0, _binaryUtils.sequence)(data.length - periods + 1).map(function (x, i) {
        return +simpleMovingAverage(data.slice(i, i + periods), config).toFixed(pipSize);
    });
};

exports.default = simpleMovingAverage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@binary-com/binary-indicators/lib/simpleMovingAverage.js
// module id = 284
// module chunks = 0